module.exports = __webpack_public_path__ + "img/SL-M-140-200.3bf7c275.svg";